<template>
	<div class="brick">
		<div class="list_top_box mgb_10">
			<div class="left_option mgb_5">
				<em class="lt_text">Date </em>
				<span class="mgr_15">
					<CustomDatePicker v-model="date_from" /> ~
					<span class="border_box"> <CustomDatePicker v-model="date_to" /> <em class="lt_text"> : Used as 'As of' </em> </span>
				</span>

				<em class="lt_text">Biz. Days </em>
				<span class="mgr_15">
					<currency-input type="text" style="width:80px;" v-model.trim="biz_days" :precision="0" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" />
				</span>

				<em class="lt_text">Elapsed Days </em>
				<span class="mgr_15">
					<currency-input type="text" style="width:80px;" v-model.trim="elapsed_days" :precision="0" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" />
				</span>

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">reset</a>
			</div>
		</div>
		<div class="half_tbl_box" style="position: relative;">
			<div class="mgb_5 brick">
				<div class="list_top_box mgb_10">
					<table class="view_tbl">
						<colgroup>
							<col style="width: 70%;" />
							<col style="width: 30%;" />
						</colgroup>
						<tbody>
							<tr>
								<td rowspan="2">
									<span class="tbl_chk mgl_15">1. Sales Progress(Monthly & Daily)</span>
								</td>
								<td style="padding: 0px;">
									<table class="view_tbl">
										<colgroup>
											<col style="width: 70%;" />
											<col style="width: 30%;" />
										</colgroup>
										<tbody>
											<tr>
												<th style="padding-top: 0px;">Biz. Days</th>
												<td style="padding: 0px 10px;">{{ saveParam.biz_days }}</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td style="padding: 0px;">
									<table class="view_tbl">
										<colgroup>
											<col style="width: 70%;" />
											<col style="width: 30%;" />
										</colgroup>
										<tbody>
											<tr>
												<th style="padding-top: 0px;">Elapsed Days</th>
												<td style="padding: 0px 10px;">{{ saveParam.elapsed_days }}</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<table class="list_tbl mgb_10">
					<colgroup>
						<col width="9%;" />
						<col width="9%;" />
						<col width="9%;" />
						<col width="9%;" />
						<col width="9%;" />
						<col width="5%;" />
						<col width="9%;" />
						<col width="9%;" />
						<col width="9%;" />
						<col width="9%;" />
						<col width="5%;" />
						<col width="9%;" />
					</colgroup>
					<thead>
						<tr>
							<th colspan="6" class="border_top border_right">Monthly Progress</th>
							<th colspan="2" class="border_top border_right">Sales Rep.</th>
							<th colspan="3" class="border_top border_right">Daily Progress</th>
							<th colspan="1" class="border_top">{{ dayOfSalesGoal }}</th>
						</tr>
						<tr>
							<th class="border_right">Target($)</th>
							<th class="border_right">Current Progress($)</th>
							<th class="border_right">Target Progress($)</th>
							<th class="border_right">Diff(%)</th>
							<th class="border_right">L.Year Compare(%)</th>
							<th class="border_right">G</th>
							<th class="border_right">Code</th>
							<th class="border_right">Name</th>
							<th class="border_right">
								<span v-if="saveParam.date_to">{{ saveParam.date_to | convertYMDToMDY }}($)</span>
							</th>
							<th class="border_right">Daily Goal($)</th>
							<th class="border_right">G</th>
							<th class="border_right">Sales's Goal($)</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(s, index) in sales_progress" :key="index">
							<td class="al_right">
								{{ s.monthly_sales_goal | toCurrency }}
								<!-- <currency-input type="text" style="width:120px;" v-model.trim="s.monthly_sales_goal" :precision="0" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" /> -->
							</td>
							<td class="al_right">{{ s.monthly_sum | toCurrency }}</td>
							<td class="al_right">{{ (s.monthly_sales_goal * elapsed_ratio) | toCurrency }}</td>
							<td class="al_center">
								<span v-if="s.monthly_sales_goal * elapsed_ratio"> {{ ((s.monthly_sum / (s.monthly_sales_goal * elapsed_ratio)) * 100) | toCurrency }} % </span>
							</td>
							<td class="al_center">
								<span v-if="s.last_year_monthly_sum">
									<font :class="{ red_bold: s.monthly_sum / s.last_year_monthly_sum > 1 }"> {{ ((s.monthly_sum / s.last_year_monthly_sum) * 100) | toCurrency }} % </font>
								</span>
							</td>
							<td class="al_center">{{ s.monthly_sum > s.monthly_sales_goal * elapsed_ratio ? 'G' : s.monthly_sales_goal * elapsed_ratio > s.monthly_sum ? '▼' : '' }}</td>
							<td class="al_center">{{ s.sales_group_code }}</td>
							<td class="al_center">{{ s.sales_group_name }}</td>
							<td class="al_right">{{ s.daily_sum | toCurrency }}</td>
							<td class="al_right">{{ saveParam.biz_days ? s.monthly_sales_goal / saveParam.biz_days : 0 | toCurrency }}</td>
							<td class="al_center">{{ saveParam.biz_days ? (s.daily_sum > s.monthly_sales_goal / saveParam.biz_days ? 'G' : s.monthly_sales_goal / saveParam.biz_days > s.daily_sum ? '▼' : '') : '' }}</td>
							<td class="al_right">{{ saveParam.biz_days ? s.monthly_sales_goal / saveParam.biz_days : 0 | toCurrency }}</td>
						</tr>
						<tr>
							<td class="al_right">{{ total_monthly_goal | toCurrency }}</td>
							<td class="al_right">{{ total_monthly_sum | toCurrency }}</td>
							<td class="al_right">{{ total_target_progress | toCurrency }}</td>
							<td class="al_center">{{ total_target_progress ? (total_monthly_sum / total_target_progress) * 100 : 0 | toCurrency }} %</td>
							<td class="al_center">
								<span v-if="total_last_year_monthly_sum">
									<font :class="{ red_bold: total_monthly_sum / total_last_year_monthly_sum > 1 }">{{ ((total_monthly_sum / total_last_year_monthly_sum) * 100) | toCurrency }} %</font>
								</span>
							</td>
							<td class="al_center">{{ total_monthly_sum > total_target_progress ? 'G' : total_target_progress > total_monthly_sum ? '▼' : '' }}</td>
							<td colspan="2" class="al_center">TOTAL</td>
							<td class="al_right">{{ total_daily_sum | toCurrency }}</td>
							<td class="al_right">{{ total_daily_goal | toCurrency }}</td>
							<td class="al_center">{{ total_daily_sum > total_daily_goal ? 'G' : total_daily_goal > total_daily_sum ? '▼' : '' }}</td>
							<td class="al_right">{{ total_daily_goal | toCurrency }}</td>
						</tr>
						<tr>
							<td class="al_center">Net Sales</td>
							<td class="al_right">{{ total_net_sales | toCurrency }}</td>
							<td class="al_right">{{ total_target_progress | toCurrency }}</td>
							<td class="al_center">{{ total_target_progress ? (total_net_sales / total_target_progress) * 100 : 0 | toCurrency }} %</td>
							<td class="al_center">
								<span v-if="total_last_year_net_sales">
									<font :class="{ red_bold: total_net_sales / total_last_year_net_sales > 1 }">{{ ((total_net_sales / total_last_year_net_sales) * 100) | toCurrency }} %</font>
								</span>
							</td>
							<td colspan="6"></td>
							<td class="al_right">{{ total_daily_goal | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big3_tbl">
				<div class="list_top_box mgb_10">
					<span class="tbl_chk mgl_15 mgr_15">2. AR Status</span>

					<span class="border_box">
						<currency-input type="text" style="width:80px;" v-model.trim="sales_month_cnt" :precision="0" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" />
						<em class="lt_text"> : Count of Months to Calculate Avg. of Sales Amt.</em>
					</span>

					<span v-if="saveParam.date_to" class="right_option tbl_chk mgr_15">AR As of {{ saveParam.date_to | convertYMDToMDY }}</span>
				</div>

				<table class="list_tbl mgb_5">
					<colgroup>
						<col width="23%;" />
						<col width="23%;" />
						<col width="23%;" />
						<col width="23%;" />
						<col width="8%;" />
					</colgroup>
					<thead>
						<th>Sales Rep.</th>
						<th>Avg. Sales Amt.</th>
						<th>Accumulation of AR</th>
						<th>Ratio</th>
						<th>A</th>
					</thead>
					<tbody>
						<tr v-for="(as, index) in ar_list" :key="index">
							<td class="al_center">{{ as.sales_group_name }}</td>
							<td class="al_right">{{ as.sales_avg | toCurrency }}</td>
							<td class="al_right">{{ as.balance_sum | toCurrency }}</td>
							<td class="al_center">{{ as.sales_avg ? as.balance_sum / as.sales_avg : 0 | toCurrency }}</td>
							<td class="al_center">{{ as.sales_avg ? (as.balance_sum / as.sales_avg > sales_ar_ratio ? '▲' : sales_ar_ratio > as.balance_sum / as.sales_avg ? '▼' : '') : '' }}</td>
						</tr>
						<tr>
							<td class="al_center">TOTAL</td>
							<td class="al_right">{{ total_sales_avg | toCurrency }}</td>
							<td class="al_right">{{ total_balance_sum | toCurrency }}</td>
							<td class="al_center">{{ sales_ar_ratio | toCurrency }}</td>
							<td></td>
						</tr>
					</tbody>
				</table>
				<p><em class="lt_text mgl_15">* Ratio = Acc. of AR / Avg. Sales Amt.</em></p>
				<p v-if="saveParam.month_from && saveParam.month_to">
					<em class="lt_text mgl_15">* Range to Calculate Avg. of Sales Amt: {{ sales_avg_calc_range }}</em>
				</p>
			</div>

			<div class="right_small3_tbl">
				<div class="list_top_box mgb_10">
					<span class="tbl_chk mgl_15 mgr_15">2-1. Monthly A/R Amount : Accumulation of AR by the End of Each Month</span>

					<span class="border_box">
						<currency-input type="text" style="width:80px;" v-model.trim="ar_month_cnt" :precision="0" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" />
						<em class="lt_text"> : Count of Months</em>
					</span>
				</div>

				<div style="width: 100%; overflow-x: auto;">
					<table class="list_tbl" :style="{ width: 150 * (ar_month_list.length + 2) + 30 + 'px' }">
						<colgroup>
							<col style="width: 150px;" />
							<col v-for="i in ar_month_list.length" :key="i" style="width: 150px;" />
							<col style="width: 30px;" />
							<col style="width: 150px;" />
						</colgroup>
						<thead>
							<tr>
								<th>Sales Rep.</th>
								<th v-for="(month, index) in ar_month_list" :key="index">{{ month.date_str | convertYMDToMDY }}</th>
								<th>C</th>
								<th>Remarks</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(ar, index) in ar_list" :key="index">
								<td class="al_center">{{ ar.sales_group_name }}</td>
								<td v-for="(month, jIndex) in ar_month_list" :key="jIndex" class="al_right">{{ ar[month.prop_name] | toCurrency }}</td>
								<td class="al_center">{{ ar.balance_sum > ar[ar_month_list[0].prop_name] ? '▲' : '' }}</td>
								<td class="al_center">
									{{ ar.sales_group_description }}
									<!-- <input type="text" class="tbl_int" v-model.trim="ar.sales_group_description" /> -->
								</td>
							</tr>
							<tr>
								<td>TOTAL</td>
								<td v-for="(month, jIndex) in ar_month_list" :key="jIndex" class="al_right">{{ total_ar_monthly[month.prop_name] | toCurrency }}</td>
								<td></td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="right_small3_tbl">
				<div class="list_top_box mgb_10">
					<span class="tbl_chk mgl_15 mgr_15">2-2. Highest Sales</span>
				</div>

				<table class="list_tbl">
					<colgroup>
						<col style="width: 25%;" />
						<col style="width: 25%;" />
						<col style="width: 25%;" />
						<col style="width: 25%;" />
					</colgroup>
					<thead>
						<th>Period</th>
						<th colspan="2">Record High</th>
						<th>Remark</th>
					</thead>
					<tbody>
						<tr v-for="(highest_sales, index) in highest_sales_list" :key="index">
							<td class="al_center">{{ highest_sales.period }}</td>
							<td class="al_right">{{ highest_sales.highest_amt | toCurrency }}</td>
							<td class="al_right">{{ highest_sales.second_highest_amt | toCurrency }}</td>
							<td class="al_center">{{ highest_sales.remark }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big3_tbl">
				<div class="list_top_box mgb_10">
					<span class="tbl_chk mgl_15 mgr_15">3. Status of Returned Goods</span>
				</div>

				<table class="list_tbl mgb_10">
					<colgroup>
						<col width="23%;" />
						<col width="23%;" />
						<col width="23%;" />
						<col width="23%;" />
						<col width="8%;" />
					</colgroup>
					<thead>
						<th>Sales Rep.</th>
						<th>Sales Amt.</th>
						<th>Return Amt.</th>
						<th>Return %</th>
						<th>A</th>
					</thead>
					<tbody>
						<tr v-for="(rt, index) in collection_list" :key="index">
							<td class="al_center">{{ rt.sales_group_name }}</td>
							<td class="al_right">{{ rt.monthly_sum | toCurrency }}</td>
							<td class="al_right">{{ rt.return_sum | toCurrency }}</td>
							<td class="al_center">
								<span v-if="rt.monthly_sum">{{ ((rt.return_sum / rt.monthly_sum) * 100) | toCurrency }} %</span>
							</td>
							<td class="al_center">{{ rt.monthly_sum ? (rt.return_sum / rt.monthly_sum > sales_return_pct ? '▲' : '') : '' }}</td>
						</tr>
						<tr>
							<td class="al_center">TOTAL</td>
							<td class="al_right">{{ total_monthly_sum | toCurrency }}</td>
							<td class="al_right">{{ total_return_sum | toCurrency }}</td>
							<td class="al_center">{{ (sales_return_pct * 100) | toCurrency }} %</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="right_small3_tbl">
				<div class="list_top_box mgb_10">
					<span class="tbl_chk mgl_15 mgr_15">4. Daily Collection Progress</span>
				</div>

				<table class="list_tbl">
					<colgroup>
						<col style="width: 25%;" />
						<col style="width: 25%;" />
						<col style="width: 25%;" />
						<col style="width: 25%;" />
					</colgroup>
					<thead>
						<tr>
							<th>Sales Rep.</th>
							<th>Sales Amt.</th>
							<th>Percentage</th>
							<th>Collection Amt.</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(c, index) in collection_list" :key="index">
							<td class="al_center">{{ c.sales_group_name }}</td>
							<td class="al_right">{{ c.monthly_sum | toCurrency }}</td>
							<td class="al_center">
								<span v-if="c.monthly_sum">{{ ((c.this_month_collection_sum / c.monthly_sum) * 100) | toCurrency }} %</span>
							</td>
							<td class="al_right">{{ c.this_month_collection_sum | toCurrency }}</td>
						</tr>
						<tr>
							<td class="al_center">TOTAL</td>
							<td class="al_right">{{ total_monthly_sum | toCurrency }}</td>
							<td class="al_center">{{ (sales_collection_pct * 100) | toCurrency }} %</td>
							<td class="al_right">{{ total_collection_sum | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="gray_bt" @click="exportExcel">Excel</a>
		</div>
	</div>
</template>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { toText, toDate, isDate, convertMDYToYMD, convertYMDToMDY, convertYMDToMMDDYY, toTextYMD, daysAdd } from '@/utils/date.js';
import { apiDailyProgress } from '@/api/report/report';
import { apiSelectSystemSettingsBykeyArr } from '@/api/basicinfo/systemsetting';
import { inputSelectOnClick } from '@/utils/etc.js';
import { excelComplicated, xlsxBorder, accounting_format_no_decimal_places } from '@/api/util';
import XLSX from 'xlsx-js-style';
export default {
	data: () => ({
		date_from: null,
		date_to: null,

		biz_days: null,
		elapsed_days: null,
		sales_month_cnt: null,
		ar_month_cnt: null,
		ar_month_list: [],

		saveParam: {},

		sales_progress: [],
		ar_list: [],
		collection_list: [],
		highest_sales_list: [],

		sales_data_list: [],
		highest_data_list: [],

		dayOfSalesGoal: daysAdd(1),
	}),
	components: {
		CustomDatePicker,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		elapsed_ratio() {
			return this.saveParam.biz_days ? (this.saveParam.elapsed_days || 0) / this.saveParam.biz_days : 0;
		},
		total_monthly_goal() {
			return this.sales_progress.reduce((prev, curr) => prev + curr.monthly_sales_goal, 0);
		},
		total_monthly_sum() {
			return this.sales_progress.reduce((prev, curr) => prev + curr.monthly_sum, 0);
		},
		total_target_progress() {
			return this.sales_progress.reduce((prev, curr) => prev + curr.monthly_sales_goal * this.elapsed_ratio, 0);
		},
		total_daily_sum() {
			return this.sales_progress.reduce((prev, curr) => prev + curr.daily_sum, 0);
		},
		total_daily_goal() {
			return this.saveParam.biz_days ? this.sales_progress.reduce((prev, curr) => prev + curr.monthly_sales_goal / this.saveParam.biz_days, 0) : 0;
		},

		total_sales_avg() {
			return this.ar_list.reduce((prev, curr) => prev + curr.sales_avg, 0);
		},
		total_balance_sum() {
			return this.ar_list.reduce((prev, curr) => prev + curr.balance_sum, 0);
		},
		sales_ar_ratio() {
			return this.total_sales_avg ? this.total_balance_sum / this.total_sales_avg : 0;
		},

		total_ar_monthly() {
			const ar_monthly = {};
			if (this.ar_list && this.ar_list.length > 0) {
				this.ar_month_list.forEach(m => {
					ar_monthly[m.prop_name] = this.ar_list.reduce((prev, curr) => prev + curr[m.prop_name], 0);
				});
			}

			return ar_monthly;
		},

		total_return_sum() {
			return this.collection_list.reduce((prev, curr) => prev + curr.return_sum, 0);
		},
		sales_return_pct() {
			return this.total_monthly_sum ? this.total_return_sum / this.total_monthly_sum : 0;
		},
		total_net_sales() {
			return this.total_monthly_sum - this.total_return_sum;
		},

		// 작년 동일기간 대비
		total_last_year_monthly_sum() {
			return this.sales_progress.reduce((prev, curr) => prev + curr.last_year_monthly_sum, 0);
		},
		total_last_year_return_sum() {
			return this.sales_progress.reduce((prev, curr) => prev + curr.last_year_return_sum, 0);
		},
		total_last_year_net_sales() {
			return this.total_last_year_monthly_sum - this.total_last_year_return_sum;
		},

		total_collection_sum() {
			return this.collection_list.reduce((prev, curr) => prev + curr.this_month_collection_sum, 0);
		},
		sales_collection_pct() {
			return this.total_monthly_sum ? this.total_collection_sum / this.total_monthly_sum : 0;
		},

		sales_avg_calc_range() {
			return (convertYMDToMDY(this.saveParam.month_from) || '') + ' ~ ' + (convertYMDToMDY(this.saveParam.month_to) || '');
		},
	},
	methods: {
		makeMonthList(month_cnt, date) {
			const month_list = [];
			if (isDate(date || '') && month_cnt) {
				const as_of_date = toDate(date);
				for (let i = 0; i < month_cnt; i++) {
					const d = new Date(as_of_date.getFullYear(), as_of_date.getMonth() - i, 0);
					month_list.push({ year: d.getFullYear(), month: d.getMonth() + 1, date: d.getDate(), date_str: toTextYMD(d), prop_name: d.getFullYear() + '_' + (d.getMonth() + 1) });
				}
			}

			return month_list;
		},
		exportExcel() {
			const date_from = convertYMDToMMDDYY(this.saveParam.date_from, '/');
			const date_to = convertYMDToMMDDYY(this.saveParam.date_to, '/');
			const data = [
				[
					{ t: 's', v: 'Confidential', cs: 2, s: { font: { bold: true, color: { rgb: 'FF0000' } }, alignment: { horizontal: 'center' } } },
					{ t: 's', v: 'Daily Sales Progress Report', cs: 6, rs: 2, s: { alignment: { vertical: 'center', horizontal: 'center' }, fill: { fgColor: { rgb: '00FFFF' } }, font: { bold: true, sz: 18 } } },
					{ t: 's', v: 'Date', s: { font: { bold: true }, alignment: { horizontal: 'right' } } },
					{ t: 's', v: `${date_from}~${date_to}`, s: { font: { bold: true } }, cs: 2 },
				],
			];
			data.push([
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: this.saveParam.biz_days, s: { border: xlsxBorder(1, -1, -1, 1), font: { bold: true }, alignment: { horizontal: 'right' } } },
				{ t: 's', v: 'Biz Days', s: { fill: { fgColor: { rgb: 'FFFCBB' } }, border: xlsxBorder(1, 1, -1, -1), font: { bold: true } } },
			]);

			// 1. Sales Progress(Monthly & Daily)
			data.push([
				{ t: 's', v: '1. Sales Progress(Monthly & Daily)', cs: 3, s: { font: { bold: true } } },
				{ t: 's', v: '', cs: 6 },
				{ t: 's', v: this.saveParam.elapsed_days, s: { border: xlsxBorder(-1, -1, 1, 1), font: { bold: true }, alignment: { horizontal: 'right' } } },
				{ t: 's', v: 'Elapsed Days', s: { fill: { fgColor: { rgb: '00FFFF' } }, border: xlsxBorder(-1, 1, 1, -1), font: { bold: true } } },
			]);
			data.push([
				{ t: 's', v: 'Monthly Progress', cs: 5, s: { border: xlsxBorder(1, -1, -1, 1), alignment: { horizontal: 'center' }, fill: { fgColor: { rgb: 'FFFCBB' } }, font: { bold: true } } },
				{ t: 's', v: 'Sales Rep.', cs: 2, s: { border: xlsxBorder(1, -1, -1, -1), alignment: { horizontal: 'center' }, fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true } } },
				{ t: 's', v: 'Daily Progress', cs: 3, s: { border: xlsxBorder(1, -1, -1, -1), alignment: { horizontal: 'center' }, fill: { fgColor: { rgb: 'B9E0FD' } }, font: { bold: true } } },
				{ t: 's', v: 'Last Year', s: { border: xlsxBorder(1, 1, 0, 1), alignment: { horizontal: 'center' }, font: { bold: true } } },
			]);

			const sales_progress_table_headers = [
				{ t: 's', v: 'Target', s: { alignment: { horizontal: 'center', vertical: 'center' }, border: xlsxBorder(-1, -1, 1, 1), font: { bold: true } }, height: { hpx: 24.25 }, width: { wch: 13 } },
				{ t: 's', v: 'Current\r\n Progress', s: { alignment: { horizontal: 'center', vertical: 'center', wrapText: true }, border: xlsxBorder(-1, -1, 1, -1), font: { bold: true } }, width: { wch: 9 } },
				{ t: 's', v: 'Target\r\n Progress', s: { alignment: { horizontal: 'center', vertical: 'center', wrapText: true }, border: xlsxBorder(-1, -1, 1, -1), font: { bold: true } }, width: { wch: 9 } },
				{ t: 's', v: 'Diff\r\n (%)', s: { alignment: { horizontal: 'center', vertical: 'center', wrapText: true }, border: xlsxBorder(-1, -1, 1, -1), font: { bold: true } }, width: { wch: 8 } },
				{ t: 's', v: 'G', s: { alignment: { horizontal: 'center', vertical: 'center' }, border: xlsxBorder(-1, -1, 1, -1), fill: { fgColor: { rgb: 'FFF8DC' } }, font: { bold: true } }, width: { wch: 2 } },
				{ t: 's', v: 'No', s: { alignment: { horizontal: 'center', vertical: 'center' }, border: xlsxBorder(-1, -1, 1, -1), font: { bold: true } }, width: { wch: 3 } },
				{ t: 's', v: 'Name', s: { alignment: { horizontal: 'center', vertical: 'center' }, border: xlsxBorder(-1, -1, 1, -1), font: { bold: true } }, width: { wch: 13 } },
				{ t: 's', v: date_to, s: { alignment: { horizontal: 'center', vertical: 'center' }, border: xlsxBorder(-1, -1, 1, -1), font: { bold: true } }, width: { wch: 9 } },
				{ t: 's', v: 'Daily\r\n Goal', s: { alignment: { horizontal: 'center', vertical: 'center', wrapText: true }, border: xlsxBorder(-1, -1, 1, -1), font: { bold: true } }, width: { wch: 9 } },
				{ t: 's', v: 'G', s: { alignment: { horizontal: 'center', vertical: 'center' }, border: xlsxBorder(-1, -1, 1, -1), fill: { fgColor: { rgb: 'FFF8DC' } }, font: { bold: true } }, width: { wch: 2 } },
			];

			sales_progress_table_headers.push({ t: 's', v: 'Comparison', s: { alignment: { horizontal: 'center', vertical: 'center' }, border: xlsxBorder(0, 1, 1, 1), font: { bold: true } }, width: { wch: 14 } });

			data.push(sales_progress_table_headers);

			this.sales_progress.forEach(sp => {
				const sales_progress_rows = [
					{ t: 'n', v: sp.monthly_sales_goal, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(-2, -1, -2, 1) } },
					{ t: 'n', v: sp.monthly_sum, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(-2, -1, -2, -1) } },
					{ t: 'n', v: sp.monthly_sales_goal * this.elapsed_ratio, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(-2, -1, -2, -1) } },
					sp.monthly_sales_goal * this.elapsed_ratio
						? {
								t: 'n',
								v: sp.monthly_sum / (sp.monthly_sales_goal * this.elapsed_ratio),
								s: { numFmt: '0.0%', border: xlsxBorder(-2, -1, -2, -1), font: { bold: true }, alignment: { horizontal: 'center' } },
						  }
						: {
								t: 's',
								v: '',
								s: { border: xlsxBorder(-2, -1, -2, -1) },
						  },
					{
						t: 's',
						v: sp.monthly_sum > sp.monthly_sales_goal * this.elapsed_ratio ? 'G' : sp.monthly_sales_goal * this.elapsed_ratio > sp.monthly_sum ? '▼' : '',
						s: { alignment: { horizontal: 'center' }, fill: { fgColor: { rgb: 'FFF8DC' } }, border: xlsxBorder(-2, -1, -2, -1), font: { bold: true } },
					},
					{ t: 's', v: sp.sales_group_code, s: { fill: { fgColor: { rgb: 'FFF8DC' } }, border: xlsxBorder(-2, -1, -2, -1), font: { bold: true }, alignment: { horizontal: 'center' } } },
					{ t: 's', v: sp.sales_group_name, s: { border: xlsxBorder(-2, -1, -2, -1), alignment: { horizontal: 'center' } } },
					{ t: 'n', v: sp.daily_sum, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(-2, -1, -2, -1) } },
					{ t: 'n', v: this.saveParam.biz_days ? sp.monthly_sales_goal / this.saveParam.biz_days : 0, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(-2, -1, -2, -1) } },
					{
						t: 's',
						v: this.saveParam.biz_days ? (sp.daily_sum > sp.monthly_sales_goal / this.saveParam.biz_days ? 'G' : sp.monthly_sales_goal / this.saveParam.biz_days > sp.daily_sum ? '▼' : '') : '',
						s: { fill: { fgColor: { rgb: 'FFF8DC' } }, border: xlsxBorder(-2, -1, -2, -1), font: { bold: true }, alignment: { horizontal: 'center' } },
					},
				];

				sales_progress_rows.push(
					sp.last_year_monthly_sum
						? {
								t: 'n',
								v: sp.monthly_sum / sp.last_year_monthly_sum,
								s: { numFmt: '0.0%', border: xlsxBorder(-2, 1, -2, -1), font: { bold: true, color: sp.monthly_sum / sp.last_year_monthly_sum > 1 ? { rgb: 'FF0000' } : undefined }, alignment: { horizontal: 'center' } },
						  }
						: {
								t: 's',
								v: '',
								s: { border: xlsxBorder(-2, 1, -2, -1) },
						  },
				);

				data.push(sales_progress_rows);
			});

			const sales_progress_total = [
				{ t: 'n', v: this.total_monthly_goal, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, 1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } } } },
				{ t: 'n', v: this.total_monthly_sum, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } } } },
				{ t: 'n', v: this.total_target_progress, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } } } },
				{
					t: 'n',
					v: this.total_target_progress ? this.total_monthly_sum / this.total_target_progress : 0,
					s: { numFmt: '0.0%', border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } }, alignment: { horizontal: 'center' } },
				},
				{
					t: 's',
					v: this.total_monthly_sum > this.total_target_progress ? 'G' : this.total_target_progress > this.total_monthly_sum ? '▼' : '',
					s: { border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } }, alignment: { horizontal: 'center' } },
				},
				{ t: 's', v: 'TOTAL', cs: 2, s: { border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } }, alignment: { horizontal: 'center' } } },
				{ t: 'n', v: this.total_daily_sum, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } } } },
				{ t: 'n', v: this.total_daily_goal, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } } } },
				{
					t: 's',
					v: this.total_daily_sum > this.total_daily_goal ? 'G' : this.total_daily_goal > this.total_daily_sum ? '▼' : '',
					s: { border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } }, alignment: { horizontal: 'center' } },
				},
			];

			sales_progress_total.push(
				this.total_last_year_monthly_sum
					? {
							t: 'n',
							v: this.total_monthly_sum / this.total_last_year_monthly_sum,
							s: {
								numFmt: '0.0%',
								border: xlsxBorder(1, 1, 1, -1),
								font: { bold: true, color: this.total_monthly_sum / this.total_last_year_monthly_sum > 1 ? { rgb: 'FF0000' } : undefined },
								alignment: { horizontal: 'center' },
								fill: { fgColor: { rgb: 'FFF8DC' } },
							},
					  }
					: {
							t: 's',
							v: '',
							s: { border: xlsxBorder(1, 1, 1, -1) },
					  },
			);
			data.push(sales_progress_total);

			const sales_progress_net = [
				{ t: 's', v: 'Net Sales', s: { border: xlsxBorder(1, -1, 1, 1), font: { bold: true }, fill: { fgColor: { rgb: 'FFFCBB' } }, alignment: { horizontal: 'center' } } },
				{ t: 'n', v: this.total_net_sales, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFFCBB' } } } },
				{ t: 'n', v: this.total_target_progress, s: { numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFFCBB' } } } },
				{
					t: 'n',
					v: this.total_target_progress ? this.total_net_sales / this.total_target_progress : 0,
					s: { numFmt: '0.0%', border: xlsxBorder(1, -1, 1, -1), font: { bold: true }, fill: { fgColor: { rgb: 'FFFCBB' } }, alignment: { horizontal: 'center' } },
				},
				{ t: 's', v: '', cs: 6 },
			];

			sales_progress_net.push(
				this.total_last_year_net_sales
					? {
							t: 'n',
							v: this.total_net_sales / this.total_last_year_net_sales,
							s: { numFmt: '0.0%', font: { bold: true, color: this.total_net_sales / this.total_last_year_net_sales > 1 ? { rgb: 'FF0000' } : undefined }, alignment: { horizontal: 'center' } },
					  }
					: {
							t: 's',
							v: '',
					  },
			);
			data.push(sales_progress_net);
			data.push([]);

			// 2. A/R Status
			data.push([
				{ t: 's', v: '2. A/R Status', s: { font: { bold: true } } },
				{ t: 's', v: '' },
				{ t: 's', v: 'As of', s: { font: { bold: true }, alignment: { horizontal: 'right' } } },
				{ t: 's', v: date_to, s: { font: { bold: true } } },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '2-1. Monthly A/R Amount', cs: 2, s: { font: { bold: true } } },
			]);
			let header_2 = [
				{ t: 's', v: 'Sales Rep.', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, 1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'Sales $', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'A/R Balance', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: date_to, s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'A', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, 1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: '' },
			];
			header_2 = header_2.concat(
				this.ar_month_list.map((m, index) => ({
					t: 's',
					v: convertYMDToMDY(m.date_str),
					s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, index === 0 ? 1 : -1), alignment: { horizontal: 'center' } },
				})),
			);
			header_2.push({ t: 's', v: 'C', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } });
			header_2.push({ t: 's', v: 'Remarks', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, 1, 1, -1), alignment: { horizontal: 'center' } } });
			data.push(header_2);
			this.ar_list.forEach(as => {
				const arr = [
					{ t: 's', v: as.sales_group_name, s: { border: xlsxBorder(-2, -1, -2, 1), alignment: { horizontal: 'center' } } },
					{ t: 'n', v: as.sales_avg, s: { border: xlsxBorder(-2, -1, -2, -1), numFmt: accounting_format_no_decimal_places } },
					{ t: 'n', v: as.balance_sum, s: { border: xlsxBorder(-2, -1, -2, -1), numFmt: accounting_format_no_decimal_places } },
					{ t: 'n', v: as.sales_avg ? as.balance_sum / as.sales_avg : 0, s: { border: xlsxBorder(-2, -1, -2, -1), numFmt: '#,##0.00', alignment: { horizontal: 'center' }, font: { bold: true } } },
					{
						t: 's',
						v: as.sales_avg ? (as.balance_sum / as.sales_avg > this.sales_ar_ratio ? '▲' : this.sales_ar_ratio > as.balance_sum / as.sales_avg ? '▼' : '') : '',
						s: { border: xlsxBorder(-2, 1, -2, -1), alignment: { horizontal: 'center' }, font: { bold: true }, fill: { fgColor: { rgb: 'FFF8DC' } } },
					},
					{ t: 's', v: '' },
				];
				this.ar_month_list.forEach((m, index) => arr.push({ t: 'n', v: as[m.prop_name], s: { border: xlsxBorder(-2, -1, -2, index === 0 ? 1 : -1), numFmt: accounting_format_no_decimal_places } }));
				arr.push({
					t: 's',
					v: as.balance_sum > as[this.ar_month_list[0].prop_name] ? '▲' : '',
					s: { border: xlsxBorder(-2, -1, -2, -1), fill: { fgColor: { rgb: 'FFF8DC' } }, alignment: { horizontal: 'center' }, font: { bold: true } },
				});
				arr.push({ t: 's', v: as.sales_group_description || '', s: { border: xlsxBorder(-2, 1, -2, -1), alignment: { horizontal: 'center' } } });

				data.push(arr);
			});
			const footer_2 = [
				{ t: 's', v: 'TOTAL', s: { fill: { fgColor: { rgb: 'C0F26D' } }, alignment: { horizontal: 'center' }, font: { bold: true }, border: xlsxBorder(1, -1, 1, 1) } },
				{ t: 'n', v: this.total_sales_avg, s: { fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true }, numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 'n', v: this.total_balance_sum, s: { fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true }, numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 'n', v: this.sales_ar_ratio, s: { fill: { fgColor: { rgb: 'C0F26D' } }, alignment: { horizontal: 'center' }, font: { bold: true }, numFmt: '#,##0.00', border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 's', v: '', s: { fill: { fgColor: { rgb: 'C0F26D' } }, border: xlsxBorder(1, 1, 1, -1) } },
				{ t: 's', v: '' },
			];
			this.ar_month_list.forEach((m, index) =>
				footer_2.push({ t: 'n', v: this.total_ar_monthly[m.prop_name], s: { fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true }, numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, index === 0 ? 1 : -1) } }),
			);
			footer_2.push({ t: 's', v: '', s: { fill: { fgColor: { rgb: 'C0F26D' } }, border: xlsxBorder(1, -1, 1, -1) } });
			footer_2.push({ t: 's', v: '', s: { fill: { fgColor: { rgb: 'C0F26D' } }, border: xlsxBorder(1, 1, 1, -1) } });
			data.push(footer_2);
			data.push([]);

			// 2-2. Highest Sales
			data.push([
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '2-2. Highest Sales', cs: 2, s: { font: { bold: true } } },
			]);
			data.push([
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: 'Period', s: { fill: { fgColor: { rgb: 'FFFCBB' } }, font: { bold: true }, alignment: { horizontal: 'center' }, border: xlsxBorder(1, -1, 1, 1) } },
				{ t: 's', v: 'Record High', cs: 2, s: { fill: { fgColor: { rgb: 'FFFCBB' } }, font: { bold: true }, alignment: { horizontal: 'center' }, border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 's', v: 'Remarks', cs: 2, s: { fill: { fgColor: { rgb: 'FFFCBB' } }, font: { bold: true }, alignment: { horizontal: 'center' }, border: xlsxBorder(1, 1, 1, -1) } },
			]);
			this.highest_sales_list.forEach((hs, index) => {
				data.push([
					{ t: 's', v: '' },
					{ t: 's', v: '' },
					{ t: 's', v: '' },
					{ t: 's', v: '' },
					{ t: 's', v: '' },
					{ t: 's', v: '' },
					{ t: 's', v: hs.period, s: { alignment: { horizontal: 'center' }, border: xlsxBorder(-2, -1, index + 1 === this.highest_sales_list.length ? 1 : -2, 1) } },
					{ t: 'n', v: hs.highest_amt, s: { border: xlsxBorder(-2, -1, index + 1 === this.highest_sales_list.length ? 1 : -2, -1), numFmt: accounting_format_no_decimal_places } },
					{ t: 'n', v: hs.second_highest_amt, s: { border: xlsxBorder(-2, -1, index + 1 === this.highest_sales_list.length ? 1 : -2, -1), numFmt: accounting_format_no_decimal_places } },
					{ t: 's', v: hs.remark, cs: 2, s: { border: xlsxBorder(-2, 1, index + 1 === this.highest_sales_list.length ? 1 : -2, -1), alignment: { horizontal: 'center' } } },
				]);
			});
			data.push([]);

			// 3. Status of Returned Goods
			data.push([
				{ t: 's', v: '3. Status of Returned Goods', cs: 2, s: { font: { bold: true } } },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '4. Daily Collection Progress', cs: 2, s: { font: { bold: true } } },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
				{ t: 's', v: '' },
			]);
			data.push([
				{ t: 's', v: 'Sales Rep.', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, 1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'C. Sales $', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'Return $', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: date_to, s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'A', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, 1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: '' },
				{ t: 's', v: 'Sales Rep.', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, 1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'C. Sales $', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: '%', s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, -1, 1, -1), alignment: { horizontal: 'center' } } },
				{ t: 's', v: 'C. Collection $', cs: 2, s: { fill: { fgColor: { rgb: 'E0FFFF' } }, font: { bold: true }, border: xlsxBorder(1, 1, 1, -1), alignment: { horizontal: 'center' } } },
			]);
			this.collection_list.forEach(rt => {
				const arr = [
					{ t: 's', v: rt.sales_group_name, s: { border: xlsxBorder(-2, -1, -2, 1), alignment: { horizontal: 'center' } } },
					{ t: 'n', v: rt.monthly_sum, s: { border: xlsxBorder(-2, -1, -2, -1), numFmt: accounting_format_no_decimal_places } },
					{ t: 'n', v: rt.return_sum, s: { border: xlsxBorder(-2, -1, -2, -1), numFmt: accounting_format_no_decimal_places } },
					rt.monthly_sum
						? {
								t: 'n',
								v: rt.return_sum / rt.monthly_sum,
								s: { numFmt: '0.0%', border: xlsxBorder(-2, -1, -2, -1), alignment: { horizontal: 'center' } },
						  }
						: {
								t: 's',
								v: '',
								s: { border: xlsxBorder(-2, -1, -2, -1) },
						  },
					{
						t: 's',
						v: rt.monthly_sum ? (rt.return_sum / rt.monthly_sum > this.sales_return_pct ? '▲' : '') : '',
						s: { fill: { fgColor: { rgb: 'FFF8DC' } }, border: xlsxBorder(-2, 1, -2, -1), font: { bold: true }, alignment: { horizontal: 'center' } },
					},
					{ t: 's', v: '' },
					{ t: 's', v: rt.sales_group_name, s: { border: xlsxBorder(-2, -1, -2, 1), alignment: { horizontal: 'center' } } },
					{ t: 'n', v: rt.monthly_sum, s: { border: xlsxBorder(-2, -1, -2, -1), numFmt: accounting_format_no_decimal_places } },
					rt.monthly_sum
						? {
								t: 'n',
								v: rt.this_month_collection_sum / rt.monthly_sum,
								s: { numFmt: '0%', border: xlsxBorder(-2, -1, -2, -1), alignment: { horizontal: 'center' } },
						  }
						: {
								t: 's',
								v: '',
								s: { border: xlsxBorder(-2, -1, -2, -1) },
						  },
					{ t: 'n', v: rt.this_month_collection_sum, cs: 2, s: { border: xlsxBorder(-2, 1, -2, -1), numFmt: accounting_format_no_decimal_places } },
				];

				data.push(arr);
			});

			data.push([
				{ t: 's', v: 'TOTAL', s: { fill: { fgColor: { rgb: 'C0F26D' } }, alignment: { horizontal: 'center' }, font: { bold: true }, border: xlsxBorder(1, -1, 1, 1) } },
				{ t: 'n', v: this.total_monthly_sum, s: { fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true }, numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 'n', v: this.total_return_sum, s: { fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true }, numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 'n', v: this.sales_return_pct, s: { fill: { fgColor: { rgb: 'C0F26D' } }, alignment: { horizontal: 'center' }, font: { bold: true }, numFmt: '0.0%', border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 's', v: '', s: { fill: { fgColor: { rgb: 'C0F26D' } }, border: xlsxBorder(1, 1, 1, -1) } },
				{ t: 's', v: '' },
				{ t: 's', v: 'TOTAL', s: { fill: { fgColor: { rgb: 'C0F26D' } }, alignment: { horizontal: 'center' }, font: { bold: true }, border: xlsxBorder(1, -1, 1, 1) } },
				{ t: 'n', v: this.total_monthly_sum, s: { fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true }, numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 'n', v: this.sales_collection_pct, s: { fill: { fgColor: { rgb: 'C0F26D' } }, alignment: { horizontal: 'center' }, font: { bold: true }, numFmt: '0%', border: xlsxBorder(1, -1, 1, -1) } },
				{ t: 'n', v: this.total_collection_sum, cs: 2, s: { fill: { fgColor: { rgb: 'C0F26D' } }, font: { bold: true }, numFmt: accounting_format_no_decimal_places, border: xlsxBorder(1, 1, 1, -1) } },
			]);

			XLSX.writeFile(
				{
					SheetNames: ['Sheet1'],
					Sheets: {
						Sheet1: excelComplicated(data, { font: { sz: 9 }, alignment: { vertical: 'center' } }, 11),
					},
				},
				'dailySalesProgress.xlsx',
			);
		},
		reset() {
			const today = new Date();
			this.date_to = toText(today, '-');
			this.date_from = toText(new Date(today.getFullYear(), today.getMonth(), 1), '-');
			this.sales_month_cnt = 4;
			this.ar_month_cnt = 3;
		},
		setArMonthList() {
			this.ar_month_list = this.makeMonthList(this.ar_month_cnt, this.date_from);
		},
		setSaveParam() {
			const date_from_dt = toDate(this.date_from);
			const sales_month_to = new Date(date_from_dt.getFullYear(), date_from_dt.getMonth(), 0);
			const sales_month_from = new Date(date_from_dt.getFullYear(), date_from_dt.getMonth() - this.sales_month_cnt, 1);

			this.saveParam = {
				date_from: convertMDYToYMD(this.date_from),
				date_to: convertMDYToYMD(this.date_to),
				month_from: toTextYMD(sales_month_from),
				month_to: toTextYMD(sales_month_to),
				date_range_from: date_from_dt > sales_month_from ? toTextYMD(sales_month_from) : convertMDYToYMD(this.date_from),
				date_range_to: convertMDYToYMD(this.date_to),
				sales_month_cnt: this.sales_month_cnt,
				ar_month_list: this.ar_month_list,

				update_setting_list: [
					{ setting_key: 'business_days', setting_value: this.biz_days },
					{ setting_key: 'elapsed_days', setting_value: this.elapsed_days },
				],

				biz_days: this.biz_days,
				elapsed_days: this.elapsed_days,
			};
		},
		makeSalesProgressData() {
			this.sales_progress = this.sales_data_list
				.filter(el => el.monthly_sales_goal || el.monthly_sum)
				.map(el => ({
					monthly_sales_goal: el.monthly_sales_goal,
					monthly_sum: el.monthly_sum,
					last_year_monthly_sum: el.last_year_monthly_sum,
					last_year_return_sum: el.last_year_return_sum,
					sales_group_code: el.sales_group_code,
					sales_group_name: el.sales_group_name,
					daily_sum: el.daily_sum,
				}));
		},
		makeArList() {
			this.ar_list = [];
			this.sales_data_list.forEach(sa => {
				const obj = {
					sales_avg: sa.sales_avg,
					balance_sum: sa.balance_sum,
				};
				this.ar_month_list.forEach(m => (obj[m.prop_name] = sa[m.prop_name]));

				let isNotEmpty = false;
				for (const prop in obj) {
					if (obj[prop]) {
						isNotEmpty = true;
						break;
					}
				}

				if (isNotEmpty) {
					obj.sales_group_code = sa.sales_group_code;
					obj.sales_group_name = sa.sales_group_name;
					obj.sales_group_description = sa.sales_group_description;

					this.ar_list.push(obj);
				}
			});
		},
		makeCollectionList() {
			this.collection_list = this.sales_data_list
				.filter(sa => sa.monthly_sales_goal || sa.monthly_sum || sa.return_sum || sa.this_month_collection_sum)
				.map(sa => ({
					sales_group_code: sa.sales_group_code,
					sales_group_name: sa.sales_group_name,
					monthly_sales_goal: sa.monthly_sales_goal,
					monthly_sum: sa.monthly_sum,
					return_sum: sa.return_sum,
					this_month_collection_sum: sa.this_month_collection_sum,
				}));
		},
		makeHighestSalesList() {
			this.highest_sales_list = [];
			this.highest_data_list.forEach(hd => {
				const idx = this.highest_sales_list.findIndex(hs => hs.period === hd.period);
				if (idx > -1) {
					let obj = this.highest_sales_list[idx];
					if (hd.invoice_amount > obj.highest_amt) {
						obj.second_highest_amt = obj.highest_amt;
						obj.highest_amt = hd.invoice_amount;
						obj.remark = hd.remark;
					} else {
						obj.second_highest_amt = hd.invoice_amount;
					}
				} else {
					this.highest_sales_list.push({
						period: hd.period,
						highest_amt: hd.invoice_amount,
						remark: hd.remark,
					});
				}
			});
		},
		async search() {
			this.setArMonthList();
			this.setSaveParam();

			const { data } = await apiDailyProgress(this.saveParam);

			this.sales_data_list = data.sales_list || [];
			this.highest_data_list = data.highest_list || [];

			this.makeSalesProgressData();
			this.makeArList();
			this.makeCollectionList();
			this.makeHighestSalesList();
		},
		findSettingValue(setting_list, key) {
			if (!Array.isArray(setting_list)) return null;

			const idx = setting_list.findIndex(s => s.setting_key === key);
			if (idx > -1) return setting_list[idx].setting_value;
			else return null;
		},
		async getSettingData() {
			const { data } = await apiSelectSystemSettingsBykeyArr(['business_days', 'elapsed_days']);

			this.biz_days = Number(this.findSettingValue(data, 'business_days'));
			this.elapsed_days = Number(this.findSettingValue(data, 'elapsed_days'));
		},
	},
	async created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_daily_sales_progress');
		this.$store.commit('setSubTitle', 'Report -> Daily Sales Progress Report');

		this.reset();
		await this.getSettingData();
		await this.search();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style scoped>
.border_right {
	border-right: 1px solid #dbdbdb;
}
.border_top {
	border-top: 2px solid #dbdbdb;
}
</style>
